export enum LanguageEnum {
  English = 'en',
  Arabic = 'ar',
}

export enum VerificationValues {
  Verified = 'Verified',
  NotVerified = 'NotVerified',
}
export enum RolesStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export enum GeneralStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}
export enum MultiplePlantRequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export enum MenuProps {
  Write = 'isWrite',
  Read = 'isRead',
  Update = 'isUpdate',
  Delete = 'isDelete',
  Approve = 'isApprove',
  Reject = 'isReject',
  Activate = 'isActivate',
  Deactivate = 'isDeactivate',
}

export enum JWTTokenValidation {
  Valid = 'valid',
  NotFound = 'NotFound',
  Expired = 'Expired',
}


export enum PermissionKeys {
  Groups = 'Groups',
  Plants = 'Plants',
  Departments = 'Departments',
  ManageUsers = 'Manage Users',
  ManageRoles = 'Manage Roles',
  Employees = 'Employees',
  MultiplePlantRequests = 'Multiple Plant Requests',
  KpiMaster = 'KPI Master Data',
  KPIFinancialGapAnalysis = 'KPI Financial Gap Analysis',
  KPIGridView = 'KPIGridView',
  KPISplitView = 'KPISplitView',
  KPITreeVersion = 'KPI Tree Version',
  KPIDataPoints = 'KPI Data Points',
  KPIIntegration = 'KPI Integration',
  KPIReports = 'KPI Reports',
  KPIGapAnalysis = 'KPI Gap Analysis',
  KPIActualEntry = 'KPI Actual Entry',
  KPITree = 'KPI Tree',
  AMMaster = 'AM Master',
  DefectConfiguration = 'Defect Configuration',
  RACIMatrix = 'RACI Matrix',
  YearlyScorecard = 'Yearly Scorecard',
  KPITargetReport = 'KPI Target Report',
  IPE = 'IPE',
  IPESummary = 'IPE Summary',
  AuditMaster = 'Audit Master',
  AMGeneralSettings = 'AM General Settings',
  AuditMasterCLI = 'AuditMasterCLI',
  CILConfiguration = 'CIL Configuration',
  ManageChecklist = 'Manage Checklist',
  Inspections = 'Inspections',
  InspectionPlan = 'Inspection Plan',
  ExecutedTaskList = 'Executed Task List',
  AuditTaskDashboard = 'Audit Task Dashboard',
  Detector = 'Detector',
  Priority = 'Priority',
  RCASWOTAnalysis = 'RCA SWOT Analysis',
  DocumentsManagement = 'Documents Management',
  CostDictionary = 'Cost Dictionary',
  DefectManagement = 'Defect Management',
  CILManagement = 'C.I.L. Management',
  ReactiveMaintenanceConfiguration = "Reactive Maintenance Configuration",
  PreventiveMaintananceConfiguration = "Preventive Maintanance Configuration",
  ScheduleTasks = "Schedule Tasks",
  ScoreMatrix = "Score Matrix",
  OperatorExecutionWindow = "Operator Execution Window",
  BOSReporting = "BOS Reporting",
  TechnicianExecutionWindow = "Technician Execution Window",
  ItemConfiguration = "Item Configuration",
  TDCMaster = "TDC Master",
  TDCActualEntry = "TDC Actual Entry",
  ConfigurationandMapping = "Configuration and Mapping",
  TDCDataPoint = "TDC DataPoints",
  TDCInput = "TDC Input Screen",
  TDCAnalysis = "TDC Analysis",
  KpiMastersDashboard = "KpiMastersDashboard",
  RMDashboard = "RM Dashboard",
  MainKPIs = "Main KPIs",
  PMDashboard = "PM Dashboard",
  ManagerExecutionWindow = "Manager Execution Window",
  AMActionPlan = "AM Action Plan",
  GembaWalk = "Gemba Walk",
  MeetingSchedular = "Meeting Schedular",
  MeetingMatrix = "Meeting Matrix",
  LossAnalysisMasterData = "Loss Analysis Master Data",
  GapAnalysis = "Gap Analysis",
  KPIMilestone = "KPI Milestone",
  PerformanceMasterSettings = 'Performance Master Settings',
  MeetingActionPlan = 'Meeting Action Plan',
  AuditExecution = 'Audit Execution',
  NewDefectDashboard = 'New DefectDashboard',
  NewFiveSGembaDashboard = 'New FiveS & Gemba Dashboard',
  NewCILDashboard = 'New CILDashBoard',
  ProcessConfirmationDashboard = 'Process Confirmation Dashboard',
  MeetingMatrixV2 = 'Meeting Matrix V2',
  ParameterAnalysisDashboard = 'Parameter Analysis Dashboard',
  DocumentManagementMaster = 'Document Management Master',
  WFConfiguration = 'WF Configuration',
  DistributionMapping = 'DistributionMapping',
  AdminConfiguration = 'Admin Configuration',
  LossAnalysisDashboard = 'Loss Analysis Dashboard',
  ActionPlan = 'Action Plan',
  GembaWalkDashboard = 'GembaWalkDashboard',
}

export enum PermissionTypes {
  IsWrite = 'isWrite',
  IsRead = 'isRead',
  IsUpdate = 'isUpdate',
  IsDelete = 'isDelete',
  IsReject = 'isReject',
  IsActivate = 'isActivate',
  IsApprove = 'isApprove',
  IsDeactivate = 'isDeactivate',
}

export enum SortDirection {
  None = '',
  Ascending = 'asc',
  Descending = 'desc',
}

export enum DaysOfWeek {
  Saturday = 'Saturday',
  Sunday = 'Sunday',
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
}

export enum Weeks {
  first = 'first',
  second = 'second',
  third = 'third',
  fourth = 'fourth',
  last = 'last',
}

export enum Months {
  January = 'January',
  February = 'February',
  March = 'March',
  April = 'April',
  May = 'May',
  June = 'June',
  July = 'July',
  August = 'August',
  September = 'September',
  October = 'October',
  November = 'November',
  December = 'December',
}

export enum TaskRepeated {
  NotRepeated = 'NotRepeated',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Quaterly = 'Quaterly',
  Yearly = 'Yearly',
}

export enum NotificationType {
  MULTIPLE_PLANT_REQUEST = 'MULTIPLE_PLANT_REQUEST',
  PLANT_REQUEST_SENT_APPROVE = 'PLANT_REQUEST_SENT_APPROVE',
  PLANT_REQUEST_SENT_REJECT = 'PLANT_REQUEST_SENT_REJECT',
}

export enum FilterDashboards {
  ThisDay = 'This Day',
  Yesterday = 'Yesterday',
  CurrentMonth = 'Current Month',
  LastMonth = 'Last Month',
  Last30Day = 'Last 30 Day',
  CustomRange = 'Custom Range',
}

export enum VarientEnum {
  WATER_VARIENT = 'WATER_VARIENT',
  HONEY_VARIENT = 'HONEY_VARIENT',
  FROZEN_FOODS_VARIENT = 'FROZEN_FOODS_VARIENT',
  FRESH_FOODS_VARIENT = 'FRESH_FOODS_VARIENT',
  PACKAGING_VARIENT = 'PACKAGING_VARIENT',
  DIARY_VARIENT = 'DIARY_VARIENT',
}
